export default __webpack_public_path__ + "static/media/slot25.097cbc5c.png";